import {
    FETCH_TAGS_SUCCESS,
} from '../actionTypes'

const initialState = []

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case(FETCH_TAGS_SUCCESS):
            return payload ? [...Object.keys(payload)] : []

        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/tagsIds.js